import React from "react";
import t from "./typography.module.css";
import c from "../colors.module.css";
import cn from "classnames";

const Quotation = ({ children, className, ...rest }) => {
  return (
    <p className={cn(t.quote, c.txtBlack, className)} {...rest}>
      {children}
    </p>
  );
};

export default Quotation;
